import { fetchService } from "./baseService";

export const fetchLinkDetailsByPublicId = (publicId) =>
    fetchService(`shared-link/${publicId}`, {
        method: "GET",
    });

export const fetchSharedLinkListingDetails = (publicId, listingID, options) =>
    fetchService(`shared-link/${publicId}/${listingID}`, {
        method: "GET",
        ...options
    });

export const sendSharedLinkContactForm = (publicId, listingID, data, options) =>
    fetchService(`shared-link/${publicId}/${listingID}/contact`, {
        method: "POST",
        body: JSON.stringify(data),
        ...options
    });